import { Button } from '@dfh-corp-sites/ui'
import { CircularProgress } from '@material-ui/core'
import React, { FC, useCallback } from 'react'

import { useDispensaryTestKitRequest } from '../../../lib/dispensaries/hooks/useDispensaryTestKitRequest'
import { useDispensaryTestKitRequestToast } from '../../../lib/dispensaries/hooks/useDispensaryTestKitRequestToast'
import type { DispensaryData } from '../../../lib/dispensaries/types'

export interface RequestTestKitCallToActionProps {
  dispensary: DispensaryData
  productSku: string
}

export const RequestTestKitCallToAction: FC<RequestTestKitCallToActionProps> = ({
  dispensary,
  productSku,
}) => {
  const [requestDispensaryTestKit, { loading, data, error }] = useDispensaryTestKitRequest()
  const { showSuccessToast, showErrorToast } = useDispensaryTestKitRequestToast()

  const handleRequest = useCallback(async () => {
    try {
      await requestDispensaryTestKit({
        dispensarySlug: dispensary.slug,
        sku: productSku,
      })
      showSuccessToast({
        message: (
          <div className="flex flex-col">
            <b>Test Requested</b>
            We&#39;ve notified your practitioner and they will get in touch soon.
          </div>
        ),
      })
    } catch (_) {
      showErrorToast({
        message: 'There was an error requesting this Spotlight Test.',
      })
    }
  }, [requestDispensaryTestKit, dispensary.slug, productSku, showSuccessToast, showErrorToast])

  return (
    <div className="flex flex-col relative mt-5">
      {loading ? (
        <Button disabled>
          <CircularProgress size={14} color="inherit" />
        </Button>
      ) : (
        <Button onClick={handleRequest} disabled={!!data && !error}>
          Request a Test
        </Button>
      )}
    </div>
  )
}
